var _excluded = ["property"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import { AllhomesListingCardGraphQL } from '@domain-group/fe-co-allhomes-listing-card';
import AllhomesListingMoreListings from './allhomes-listing-more-listings-graphql-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingMoreListings on Property {\n    agents {\n      name\n      profileUrl\n      listings {\n        listings(requestType: OTHER_LISTINGS) {\n          ...ListingCard\n        }\n      }\n    }\n    listing {\n      type\n    }\n  }\n  ", "\n"])), AllhomesListingCardGraphQL.fragment);
export var graphQLToProps = function graphQLToProps() {
  var _agents$, _agents$2, _agents$2$listings, _agents$3;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$agents = _ref.agents,
    agents = _ref$agents === void 0 ? [] : _ref$agents,
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing;
  return {
    name: (_agents$ = agents[0]) === null || _agents$ === void 0 ? void 0 : _agents$.name,
    items: (_agents$2 = agents[0]) === null || _agents$2 === void 0 ? void 0 : (_agents$2$listings = _agents$2.listings) === null || _agents$2$listings === void 0 ? void 0 : _agents$2$listings.listings,
    profileUrl: (_agents$3 = agents[0]) === null || _agents$3 === void 0 ? void 0 : _agents$3.profileUrl,
    listingType: ListingType[listing.type].shortLabel
  };
};
var AllhomesListingMoreListingsGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(AllhomesListingMoreListings, _extends({}, graphQLToProps(property), props));
};
AllhomesListingMoreListingsGraphQL.fragment = fragment;
AllhomesListingMoreListingsGraphQL.propTypes = {
  property: PropTypes.shape({
    agents: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      profileUrl: PropTypes.string
    }))
  })
};
AllhomesListingMoreListingsGraphQL.defaultProps = {
  property: {}
};
export default AllhomesListingMoreListingsGraphQL;